import React, { useReducer, useState } from 'react';
import jwtDecode from 'jwt-decode';

// components
import { Modal, Button, Form } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';

// Form Imports
import formField from '../../functions/formField';
import formReducer from '../../functions/formReducer';
import formValidator from '../../functions/formValidator';

//  Constants
import { PASSWORD_MISMATCH } from '../../constants/status';

const initialState = {
    currentPassword: formField('', [8, 25]),
    newPassword: formField('', [8, 25]),
    verifyNewPassword: formField('', [8, 25], 'verification', {
        verifyParam: 'newPassword'
    })
};

const ChangePasswordModal = (props) => {
    const [state, dispatch] = useReducer(formReducer, initialState);
    const [loading, setLoading] = useState(false);

    const updatePassword = async () => {
        const isFormValid = !formValidator(state, dispatch);
        if (isFormValid) {
            setLoading(true); // Start Loading Spinner
            const url = process.env.REACT_APP_API_URL;
            const authToken = sessionStorage.getItem('auth-token');
            const userInfo = jwtDecode(authToken);

            const request = await fetch(`${url}/users/${userInfo.id}/password`,
                {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify({
                        current: state.currentPassword.value,
                        newPassword: state.newPassword.value
                    })
                });

            const response = await request.json();

            setLoading(false);
            if (request.status === 200) {
                // Close Modal when finished
                props.close();
            } else {
                switch (response.status) {
                    case PASSWORD_MISMATCH:
                        dispatch({ type: 'ADD_ERROR', param: 'currentPassword', message: 'La contraseña actual es incorrecta' })
                        break
                    default:
                }
            }
        }
    }

    return (
        <Modal
            show={props.show}
            onShow={() => dispatch({ type: 'CLEAR', default: initialState })}
            onHide={props.close} centered>
            <Modal.Header>
                <Modal.Title>Cambia tu Contraseña</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Contraseña actual</Form.Label>
                        <Form.Control
                            value={state.currentPassword.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'currentPassword', value: e.target.value })}
                            type="password"
                            isInvalid={state.currentPassword.hasError} />
                        <Form.Control.Feedback type="invalid">{state.currentPassword.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Contraseña Nueva</Form.Label>
                        <Form.Control value={state.newPassword.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'newPassword', value: e.target.value })}
                            type="password"
                            isInvalid={state.newPassword.hasError} />
                        <Form.Control.Feedback type="invalid">{state.newPassword.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Confirme Contraseña Nueva</Form.Label>
                        <Form.Control value={state.verifyNewPassword.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'verifyNewPassword', value: e.target.value })}
                            type="password"
                            isInvalid={state.verifyNewPassword.hasError} />
                        <Form.Control.Feedback type="invalid">{state.verifyNewPassword.errorMessage}</Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={props.close}>Cerrar</Button>
                <Button variant="success" onClick={updatePassword}>
                    <span>Cambiar Contraseña</span>
                    {loading && <LoadingSpinner size="sm" inButton />}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ChangePasswordModal;